import React, { Component } from 'react';
import qs from 'qs';
import { withRouter } from 'react-router-dom';
import {
  Checkbox,
  Grid,
  Button,
  Header,
  List,
  Image,
  Icon,
  Loader,
  Modal,
  Divider,
  Form,
  Rating,
} from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';
import { Media } from 'src/utils/Media';

// redux
import { push } from 'connected-react-router';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import moment from 'moment';
import { toast } from 'react-toastify';

import styled from 'styled-components';

import { updateUserProfile, fetchCountryOptions } from '../../modules/user';

// utils
import { uxAnalyticsUtil, authUtil } from '../../utils';
import Avatar from '../../components/avatar/avatar';

import GenreList from '../../components/lists/genreList';
import LanguageList from '../../components/lists/languageList';
import DisplayNameGetter from './userProfileBuilder/fields/displayName';
import YoBGetter from './userProfileBuilder/fields/yob';
import GenderGetter from './userProfileBuilder/fields/gender';
import GenresGetter from './userProfileBuilder/fields/genresGetter';
import LanguagesGetter from './userProfileBuilder/fields/languages';
import BioGetter from './userProfileBuilder/fields/bio';
import AiManuscriptPreference from './userProfileBuilder/fields/aiManuscriptPreference';
import RoleGetter from './userProfileBuilder/fields/role';
import Country from './userProfileBuilder/fields/country';

import InviteReader from '../readerIndex/inviteReader';
import SocialProfileLinks from '../readers/components/socialProfileLinks';
import SocialProfiles from './userProfileBuilder/fields/socialProfiles';
import ProfilePhotoUpload from './components/profilePhotoUpload';
import BlockUserButton from '../../components/user/blockUserButton';
import HoverHelp from '../../components/help/hoverHelp';
import UserReviewsModal from '../../components/user/userReviewsModal';

const MainWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding-bottom: 1em;
`;

const CoverContainer = styled.div`
  min-height: 200px;
  height: 200px;
  width: 100%;
  align-items: center;
  display: flex;
  overflow: hidden;
  position: relative;
`;

const AvatarContainer = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ProfileContainer = styled.div`
  flex: 1;
  width: 100%;
`;

const EditIcon = (
  <Icon size="small" name="pencil" style={{ marginLeft: 5, opacity: 0.4 }} />
);

/**
 * Splits a stat label into the part that may wrap and the part that must not.
 *
 * The turnaround label is longer than a phone column, so it wraps — and the
 * help icon was ending up orphaned on a line of its own below it. A trailing
 * non-breaking space is not enough: a line break is still allowed in front of
 * an inline-level box, whatever precedes it. Keeping the value and the icon
 * inside one `white-space: nowrap` span is what actually binds them.
 *
 * The value and its unit are already joined by a non-breaking space inside the
 * translated string, so the last ordinary space is the one in front of the
 * value.
 */
export const splitOffStatValue = label => {
  const cut = label.lastIndexOf(' ');
  if (cut === -1) {
    return { head: '', value: label };
  }
  return { head: label.slice(0, cut + 1), value: label.slice(cut + 1) };
};

export class PublicUserProfile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userInfo: undefined,
      userData: undefined,
    };
  }

  componentDidMount() {
    const { props } = this;
    const { location } = props.history;
    uxAnalyticsUtil.trackPageView(
      location.pathname + location.hash + location.search
    );
    this.reset();
    this.getUserInfo();
    this.getUserData();
    this.getCountryOptions();
    const queryObject = qs.parse(this.props.location.search, {
      ignoreQueryPrefix: true,
    });
    if (queryObject.show) {
      this.setState({ showModal: queryObject.show });
    }
  }

  reset = () => {
    this.setState({
      userInfo: undefined,
      userData: undefined,
    });
  };

  getUserInfo = async () => {
    const { match, t } = this.props;
    const { userId, userProfile } = this.props;
    const matchUserId = match.params.userId;
    if (!matchUserId && !userId && !userProfile) {
      return; // we don't know who to look for
    }
    const idToken = await authUtil.getFreshIdToken();
    this.setState(
      {
        // clear old data and set refreshing to true
        refreshing: true,
        err: undefined,
      },
      async () => {
        // has user ID, go ahead and fetch
        fetch(
          `${process.env.REACT_APP_API_HOST}${
            process.env.REACT_APP_API_PATH
          }/users/${matchUserId || userId || userProfile._id}`,
          {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              'br-token': idToken,
            },
          }
        )
          .then(res => res.json())
          .then(userInfo => {
            if (userInfo.err) {
              return toast.error(t('SomethingWentWrong'));
            }
            // if the user had a profile
            this.setState({ userInfo });
          })
          .catch(err => {
            console.error(err);
          })
          .finally(() => {
            this.setState({
              refreshing: false,
            });
          });
      }
    );
  };

  getUserData = async () => {
    const { match } = this.props;
    const { userId, userProfile } = this.props;
    const matchUserId = match.params.userId;
    if (!matchUserId && !userId && !userProfile) {
      return; // we don't know who to look for
    }
    const idToken = await authUtil.getFreshIdToken();
    // has user ID, go ahead and fetch
    fetch(
      `${process.env.REACT_APP_API_HOST}${
        process.env.REACT_APP_API_PATH
      }/users/${matchUserId || userId || userProfile._id}/data`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'br-token': idToken,
        },
      }
    )
      .then(res => res.json())
      .then(userData => {
        // if the user had a profile
        this.setState({
          userData,
        });
      })
      .catch(err => {
        console.error(err);
      })
      .finally(() => {
        this.setState({
          refreshing: false,
        });
      });
  };

  getCountryOptions = async () => {
    const { userProfile } = this.props;
    const idToken = await authUtil.getFreshIdToken();

    this.props.fetchCountryOptions(
      idToken,
      (userProfile && userProfile.language) || 'en'
    );
  };

  getJoinDate = () => {
    const { userInfo } = this.state;
    if (
      Date.now() - new Date(userInfo.createdAt).getTime() >
      1000 * 60 * 60 * 24 * 30
    ) {
      // if more than a month ago, return the date
      return moment(userInfo.createdAt).format('L');
    }
    // otherwise return a time ago string
    return moment(userInfo.createdAt).fromNow();
  };

  isEditable = () => {
    const { userProfile } = this.props;
    const { userInfo } = this.state;
    return userProfile && userInfo && userInfo._id === userProfile._id;
  };

  showModal = fieldName => {
    if (!this.isEditable()) {
      // don't open the modal if we're not going to be able to edit it
      return;
    }
    this.setState({
      showModal: fieldName,
    });
  };

  hideModal = () => {
    this.setState({
      showModal: false,
    });
  };

  updateProfile = async data => {
    const { t } = this.props;
    const idToken = await authUtil.getFreshIdToken();
    if (idToken) {
      this.props.updateUserProfile(idToken, { ...data }, success => {
        if (success) {
          // refresh user info if update was successful
          this.getUserInfo();
        } else {
          toast.error(t('SomethingWentWrong'));
        }
        // always close the modal
        this.hideModal();
      });
    }
  };

  handlePhotoUpdate = photoUrl => {
    // Update the local state immediately for better UX
    this.setState(prevState => ({
      userInfo: {
        ...prevState.userInfo,
        photoUrl: photoUrl,
      },
    }));

    // Also refresh the user info to ensure consistency
    this.getUserInfo();
  };

  getGenderLabel = genderKey => {
    const { t } = this.props;
    const genderKeys = {
      m: 'male',
      f: 'female',
      o: 'other',
      na: 'DontWantToShare',
    };
    if (genderKeys[genderKey]) {
      return t(genderKeys[genderKey]);
    }
    return t('NotSpecified');
  };

  handleInviteClick = () => {
    const { userInfo } = this.state;
    this.setState({ showModal: { inviteReader: userInfo } });
  };

  render() {
    const { userInfo, userData, refreshing, showModal } = this.state;
    const { t, countryOptions, userProfile } = this.props;
    if (refreshing) return <Loader />;
    if (!userInfo || userInfo.err) return null;
    const selectedCountry =
      countryOptions &&
      countryOptions.find(country => {
        const isMatch = country.key === userInfo.country;
        return isMatch;
      });
    // users can edit their own user data
    const editable = this.isEditable();
    return (
      <MainWrapper>
        <CoverContainer>
          {userInfo.coverURL && <Image fluid src={userInfo.coverURL} />}
          <AvatarContainer>
            {editable ? (
              <ProfilePhotoUpload
                currentPhotoUrl={userInfo.photoUrl}
                onPhotoUpdate={photoUrl => this.handlePhotoUpdate(photoUrl)}
                size={112}
              />
            ) : (
              <Avatar
                name={userInfo.displayName}
                src={userInfo.photoUrl}
                diameter={112}
              />
            )}
          </AvatarContainer>
        </CoverContainer>
        <ProfileContainer>
          <Grid
            columns="equal"
            style={{ paddingLeft: 5, paddingRight: 5 }}
            stackable
          >
            <Grid.Row>
              <Grid.Column>
                <Header
                  content={
                    <div
                      className={editable ? 'editable' : undefined}
                      style={{ display: 'flex', alignItems: 'center' }}
                      onClick={() => this.showModal('displayName')}
                      onKeyDown={event => {
                        if (event.keyCode === 13) {
                          this.showModal('displayName');
                        }
                      }}
                    >
                      <span>{userInfo.displayName}</span>
                      {userInfo.socialProfiles && (
                        <SocialProfileLinks
                          socialProfiles={userInfo.socialProfiles}
                          style={{
                            marginLeft: 10,
                            marginTop: 0,
                            display: 'inline-flex',
                            alignItems: 'center',
                          }}
                        />
                      )}
                      {editable && EditIcon}
                      {userData && userData.averageRating && (
                        <div
                          style={{
                            marginLeft: 10,
                            display: 'flex',
                            alignItems: 'center',
                          }}
                          title={t('AverageRatingTooltip', {
                            rating: userData.averageRating,
                            count: userData.reviewCount,
                          })}
                        >
                          <Rating
                            icon="star"
                            rating={Math.round(userData.averageRating * 2) / 2}
                            maxRating={5}
                            disabled
                            size="mini"
                          />
                          <span
                            style={{
                              fontSize: '0.7em',
                              marginLeft: 5,
                              color: '#666',
                            }}
                          >
                            ({userData.reviewCount})
                          </span>
                        </div>
                      )}
                    </div>
                  }
                  subheader={
                    <div
                      style={{
                        fontWeight: 'normal',
                        fontSize: '0.7em',
                        opacity: 0.8,
                      }}
                    >
                      {t('Joined')}
                      {': '}
                      {this.getJoinDate()}
                      {userData && (
                        <React.Fragment>
                          <Media greaterThan="mobile">
                            {() => <span>{' | '}</span>}
                          </Media>
                          <Media at="mobile">{() => <br />}</Media>
                          {/*
                            Show books joined AND books completed side by side.
                            A single "books read" figure could not distinguish a
                            reader who finishes what they take on from an account
                            that only collects access, so an account with nothing
                            but access now reads plainly as "50 joined · 0
                            completed". Purely informational — no flagging.
                          */}
                          {t('BooksJoinedAndCompleted', {
                            joined: userData.read || 0,
                            completed: userData.booksCompleted || 0,
                          })}
                          {userData.avgTurnAroundTimeFor1kWords && (
                            <span>
                              <Media greaterThan="mobile">
                                {() => <span>{' | '}</span>}
                              </Media>
                              <Media at="mobile">{() => <br />}</Media>
                              {/*
                                The label is longer than a phone column, so it
                                wraps — and the icon was ending up orphaned on a
                                line of its own below it. Holding the value and
                                the icon in one nowrap span moves the wrap in
                                front of the value instead, so the last line
                                reads "1.67 days ?".
                              */}
                              {
                                splitOffStatValue(
                                  t('AvgTurnAroundTimePer1kWords', {
                                    count: Number(
                                      userData.avgTurnAroundTimeFor1kWords
                                    ),
                                  })
                                ).head
                              }
                              <span style={{ whiteSpace: 'nowrap' }}>
                                {
                                  splitOffStatValue(
                                    t('AvgTurnAroundTimePer1kWords', {
                                      count: Number(
                                        userData.avgTurnAroundTimeFor1kWords
                                      ),
                                    })
                                  ).value
                                }
                                {/*
                                  The metric is not self-explanatory, so explain
                                  it on demand — floating over the page, so the
                                  stats line does not jump when it opens.
                                */}
                                <HoverHelp
                                  label={t('WhatDoesThisMean')}
                                  content={t(
                                    'AvgTurnAroundTimePer1kWordsInfo'
                                  )}
                                />
                              </span>
                            </span>
                          )}
                        </React.Fragment>
                      )}
                    </div>
                  }
                />
                {
                  // if the current user IS NOT the owner of this profile,
                  // show the invitation button if applicable
                  userProfile._id !== userInfo._id && (
                    <Button.Group compact>
                      {userInfo.readerListConsent && (
                        <Button
                          compact
                          icon="mail"
                          content={t('Invite')}
                          onClick={this.handleInviteClick}
                        />
                      )}
                      <BlockUserButton
                        userId={userInfo._id}
                        displayName={userInfo.displayName}
                        compact
                      />
                      {/* <Button
                        compact
                        icon='feed'
                        content={t('Follow')}
                        onClick={this.handleInviteClick}
                      /> */}
                    </Button.Group>
                  )
                }
                {
                  // if the current user IS the owner of this profile,
                  // show the reader database toggle
                  userProfile._id === userInfo._id && (
                    <React.Fragment>
                      <div>
                        <Checkbox
                          label={t('AvailableToRead')}
                          toggle
                          onChange={(event, data) =>
                            this.updateProfile({
                              readerListConsent: data.checked,
                            })
                          }
                          checked={userInfo.readerListConsent}
                        />
                      </div>
                      {userInfo.readerListConsent && (
                        <div style={{ fontSize: '0.8em' }}>
                          <em>{t('ReaderListConsentInfo')}</em>
                        </div>
                      )}
                    </React.Fragment>
                  )
                }
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column>
                <Header sub content={t('UserInfo')} />
                <List>
                  <List.Item
                    className={editable ? 'editable' : undefined}
                    style={{ display: 'flex', alignItems: 'center' }}
                    onClick={() => this.showModal('yob')}
                  >
                    <Icon name="id badge outline" />
                    {t('Age')}
                    {': '}
                    {userInfo.age || t('NotSpecified')}
                    {editable && EditIcon}
                  </List.Item>
                  <List.Item
                    className={editable ? 'editable' : undefined}
                    style={{ display: 'flex', alignItems: 'center' }}
                    onClick={() => this.showModal('gender')}
                  >
                    <Icon name="transgender" />
                    {t('Gender')}
                    {': '}
                    {this.getGenderLabel(userInfo.gender)}
                    {editable && EditIcon}
                  </List.Item>
                  <List.Item
                    className={editable ? 'editable' : undefined}
                    style={{ display: 'flex', alignItems: 'center' }}
                    onClick={() => this.showModal('role')}
                  >
                    <Icon name="user" />
                    {t('Role')}
                    {': '}
                    {userInfo.roleKey ? t(userInfo.roleKey) : t('NotSpecified')}
                    {editable && EditIcon}
                  </List.Item>
                  <List.Item
                    className={editable ? 'editable' : undefined}
                    style={{ display: 'flex', alignItems: 'center' }}
                    onClick={() => this.showModal('country')}
                  >
                    <Icon name="globe" />
                    {t('Country')}
                    {': '}
                    {(selectedCountry && selectedCountry.name) ||
                      userInfo.country}
                    {editable && EditIcon}
                  </List.Item>
                </List>
                <Header
                  className={editable ? 'editable' : undefined}
                  sub
                  onClick={() => this.showModal('bio')}
                  content={
                    <div>
                      <span>{t('Bio')}</span>
                      {editable && EditIcon}
                    </div>
                  }
                />
                <span style={{ wordWrap: 'break-word' }}>
                  {userInfo.bio && userInfo.bio.length > 0
                    ? userInfo.bio
                    : t('NotSpecified')}
                </span>
              </Grid.Column>
              <Grid.Column>
                <Header
                  className={editable ? 'editable' : undefined}
                  sub
                  onClick={() => this.showModal('socialProfiles')}
                  content={
                    <div>
                      <span>{t('SocialProfiles')}</span>
                      {editable && EditIcon}
                    </div>
                  }
                />
                {userInfo.socialProfiles &&
                Object.values(userInfo.socialProfiles).some(url => url) ? (
                  <SocialProfileLinks
                    socialProfiles={userInfo.socialProfiles}
                    style={{ marginBottom: 10 }}
                  />
                ) : (
                  <span>{t('NotSpecified')}</span>
                )}
                <Header
                  className={editable ? 'editable' : undefined}
                  sub
                  onClick={() => this.showModal('genres')}
                  content={
                    <div>
                      <span>{t('PreferredGenres')}</span>
                      {editable && EditIcon}
                    </div>
                  }
                />
                <GenreList
                  genres={userInfo.preferredGenres}
                  noInfoMessage={t('NotSpecified')}
                />
                <Header
                  className={editable ? 'editable' : undefined}
                  sub
                  onClick={() => this.showModal('languages')}
                  content={
                    <div>
                      <span>{t('PreferredLanguages')}</span>
                      {editable && EditIcon}
                    </div>
                  }
                />
                <LanguageList
                  languages={userInfo.preferredLanguages}
                  noInfoMessage={t('NotSpecified')}
                />
                {editable && (
                  <div style={{ marginTop: '1.5em' }}>
                    <Header sub content={t('ReadingPreferences')} />
                    <AiManuscriptPreference
                      initialValue={userProfile.showAiGeneratedManuscripts}
                      updating={this.props.updatingUserProfile?.includes('showAiGeneratedManuscripts')}
                      onUpdate={async data => {
                        const idToken = await authUtil.getFreshIdToken();
                        this.props.updateUserProfile(idToken, data);
                      }}
                    />
                  </div>
                )}
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </ProfileContainer>
        {showModal === 'review' && userInfo && (
          <UserReviewsModal
            open={true}
            onClose={this.hideModal}
            user={userInfo}
          />
        )}
        {showModal && showModal !== 'review' && (
          <Modal open onClose={this.hideModal}>
            <Modal.Content>
              <Modal.Description>
                {showModal === 'displayName' && (
                  <DisplayNameGetter
                    initialValue={userInfo.displayName}
                    onUpdate={this.updateProfile}
                  />
                )}
                {showModal === 'yob' && (
                  <YoBGetter
                    initialValue={userInfo.yob}
                    onUpdate={this.updateProfile}
                  />
                )}
                {showModal === 'gender' && (
                  <GenderGetter
                    initialValue={userInfo.gender}
                    onUpdate={this.updateProfile}
                  />
                )}
                {showModal === 'genres' && (
                  <GenresGetter
                    initialValue={userInfo.preferredGenres}
                    onUpdate={value =>
                      this.updateProfile({ preferredGenres: value })
                    }
                  />
                )}
                {showModal === 'languages' && (
                  <LanguagesGetter
                    initialValue={
                      userInfo.preferredLanguages &&
                      userInfo.preferredLanguages.map(lang => lang.key)
                    }
                    onUpdate={value =>
                      this.updateProfile({ preferredLanguages: value })
                    }
                  />
                )}
                {showModal === 'bio' && (
                  <BioGetter
                    initialValue={userInfo.bio}
                    onUpdate={this.updateProfile}
                  />
                )}
                {showModal === 'role' && (
                  <RoleGetter
                    initialValue={userInfo.role}
                    onUpdate={this.updateProfile}
                  />
                )}
                {showModal === 'socialProfiles' && (
                  <Form>
                    <SocialProfiles
                      socialProfiles={userInfo.socialProfiles || {}}
                      onChange={socialProfiles =>
                        this.updateProfile({ socialProfiles })
                      }
                    />
                  </Form>
                )}
                {showModal.inviteReader && (
                  <InviteReader
                    reader={showModal.inviteReader}
                    onClose={() => this.setState({ showModal: false })}
                  />
                )}
                {showModal === 'country' && (
                  <Country
                    initialValue={userInfo.country}
                    onUpdate={this.updateProfile}
                  />
                )}
                <Divider hidden />
              </Modal.Description>
            </Modal.Content>
          </Modal>
        )}
      </MainWrapper>
    );
  }
}

// redux stuff
const mapStateToProps = state => ({
  userProfile: state.user.userProfile,
  countryOptions: state.user.countryOptions,
  updatingUserProfile: state.user.updatingUserProfile,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      updateUserProfile,
      fetchCountryOptions,
      changePage: newPage => push(newPage),
    },
    dispatch
  );

export default withTranslation()(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(PublicUserProfile))
);
